export default {
  methods: {
    joinKpi(kpi1, kpi2) {
      if (!kpi1 && !kpi2) return null;
      if (!kpi1 || !kpi2) return kpi1 ?? kpi2;

      // Add waves to kpi1, avoid duplicates
      kpi2.SurveyWave.forEach(el => {
        if (!_.find(kpi1.SurveyWave, { 'Year': el.Year, 'Name': el.Name }))
          kpi1.SurveyWave.push(el);
      });

      // sort waves
      kpi1.SurveyWave = _.sortBy(kpi1.SurveyWave, ['Year', 'Name']);
      return kpi1;
    }
  }
};
